import classnames from 'classnames';
import styles from './FJVerticalScroller.module.less';
import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import FJConstant from '../../../constants/FJConstant';
import _ from 'lodash';
import FJEvent from '../../../store/FJEvent.js';

const FJVerticalScroller = (
    { className, onScroll, onScrollStart, onTotalScroll, onMouseWheel, totalScrollThreshold = 50, children, ...props },
    ref,
) => {
    const _isMouseWheelDown = useRef(false); // 向下滑动
    const scrollerRef = useRef();

    useImperativeHandle(ref, () => {
        return {
            scrollTop: (top, behavior = 'auto') => {
                scrollerRef.current.scroll({ top, behavior });
            },
            scrollToBottom: () => {
                scrollerRef.current.scrollTop = scrollerRef.current.scrollHeight;
            },
            getScroller: () => scrollerRef.current,
        };
    });

    useEffect(() => {
        const onScrollDebounce = onTotalScroll
            ? _.debounce(
                  () => {
                      if (
                          onTotalScroll &&
                          _isMouseWheelDown.current &&
                          scrollerRef.current.scrollTop + scrollerRef.current.offsetHeight >=
                              scrollerRef.current.scrollHeight - totalScrollThreshold
                      ) {
                          onTotalScroll();
                      }
                      _isMouseWheelDown.current = false;
                  },
                  200,
                  { trailing: true },
              )
            : undefined;

        const scroll = () => {
            if (onScroll) {
                onScroll();
            }

            if (onScrollStart) {
                onScrollStart();
            }

            onScrollDebounce && onScrollDebounce();

            requestAnimationFrame(() => {
                FJEvent.dispatch(FJConstant.HIDE_TOOLTIP);
            });
        };
        const wheel = e => {
            if (e.deltaY > 0) {
                _isMouseWheelDown.current = true;
            }
            if (onMouseWheel) onMouseWheel(e);
        };
        scrollerRef.current.addEventListener('scroll', scroll);
        scrollerRef.current.addEventListener('wheel', wheel);
        return () => {
            if (scrollerRef.current) {
                scrollerRef.current.removeEventListener('scroll', scroll);
                scrollerRef.current.removeEventListener('wheel', wheel);
            }
        };
    }, [onTotalScroll, totalScrollThreshold]);

    const cn = classnames(styles.scroller_vertical, className);

    return (
        <div className={cn} ref={scrollerRef} {...props}>
            {children}
        </div>
    );
};

export default forwardRef(FJVerticalScroller);
